import styled from 'styled-components'

export const ReferenceBadge = styled.span<{ $color: string }>`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 2px 8px;
  border-radius: ${({ theme }) => theme.borderRadius.small};
  background: ${({ $color }) => $color}15;
  color: ${({ $color }) => $color};
  font-size: ${({ theme }) => theme.typography.fontSize.micro};
  font-weight: ${({ theme }) => theme.typography.fontWeight.medium};
  margin-top: 4px;
  cursor: help;
  transition: all 0.2s;

  &:hover {
    background: ${({ $color }) => $color}25;
  }
`

export const TooltipContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  font-size: ${({ theme }) => theme.typography.fontSize.small};
`

export const TooltipRow = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
`

export const TooltipLabel = styled.span`
  font-weight: ${({ theme }) => theme.typography.fontWeight.semibold};
  color: ${({ theme }) => theme.colors.text.primary};
  font-size: ${({ theme }) => theme.typography.fontSize.micro};
  text-transform: uppercase;
  letter-spacing: 0.5px;
`

export const TooltipValue = styled.span`
  color: ${({ theme }) => theme.colors.text.secondary};
`

export const DocumentLink = styled.a`
  color: ${({ theme }) => theme.colors.primary};
  text-decoration: none;
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-weight: ${({ theme }) => theme.typography.fontWeight.medium};

  &:hover {
    text-decoration: underline;
  }
`
